module.exports = __webpack_public_path__ + "static/media/weblink.8abe57a7.svg";